import React, { Component } from "react";
import { ModalContentGrid, ModalContentGridColumn, ModalContentGridLoading, ModalContentGridLoadingContent, RegisterBudgetModal, RegisterBudgetModalContent, RegisterBudgetModalContentFilter, RegisterBudgetModalContentFilterSelector, RegisterBudgetResumeContentModalFilterButton, RegisterBudgetResumeContentModalFilterButtonWhite } from "../../../pages/Vendas/CadastroOrcamento/styles";
import { BillingDataContainerModal, BillingDataContainerModalContent, BillingDataContainerModalContentFilter, BillingDataContainerModalContentFilterButton, BillingDataContainerModalContentFilterButtonWhite, BillingDataContainerModalContentFilterSelect, BillingDataContainerModalContentGrid, BillingDataContainerModalContentGridColumn, BillingDataContainerModalContentGridLoading, BillingDataContainerModalContentGridLoadingContent } from "./styles";
const loading = "/images/loading-blue.gif";

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      view_loading: false,
      texto_buscado: "",
    };
    this.config = this.props.config;
  }

  componentDidMount() {
    if (this.props.title_filter == "sem filtro" || this.props.autosearch) {
      this.filter();
    }
  }

  filter = async () => {
    try {
      this.setState({ view_loading: true });
      if (
        this.props.call.method != undefined &&
        this.props.call.method.toLowerCase() == "get"
      ) {
        if (this.props.call.param != undefined) {
          var param = this.props.call.param.join("/");
          const response = await this.props.call.endpoint.get("/" + param);
          var data = response.data;
        } else {
          const response = await this.props.call.endpoint.get();
          var data = response.data;
        }
      } else {
        const response = await this.props.call.endpoint.post(
          "",
          "{" +
            this.props.call.param.map((data) => {
              return (
                '"' +
                [data.field] +
                '":"' +
                this[this.ifnull(data.find, "")][this.ifnull(data.field, "")] +
                '"'
              );
            }) +
            "}"
        );
        var data = response.data;
      }

      this.setState({ dados: data, view_loading: false });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  changeInputField = async (e, value) => {
    this.setState({ [value]: e.target.value });
    if (e.key == "Enter") {
      this.filter();
    }
  };

  ifnull(a, b) {
    if (a == undefined || a == null || a == "") {
      return b;
    } else {
      return a;
    }
  }

  render() {
    const { dados } = this.state;

    return (
      <BillingDataContainerModal>
        <BillingDataContainerModalContent>
          <BillingDataContainerModalContentFilter>
            <BillingDataContainerModalContentFilterSelect>
              {this.props.title_filter != "sem filtro" ? (
                <label>
                  {this.props.title_filter}:{" "}
                </label>
              ) : (
                <div></div>
              )}
              {this.props.title_filter != "sem filtro" ? (
                <input
                  name="texto_buscado"
                  type="text"
                  onKeyPress={(e) => this.changeInputField(e, "texto_buscado")}
                  onChange={(e) => this.changeInputField(e, "texto_buscado")}
                />
              ) : (
                <div></div>
              )}
            </BillingDataContainerModalContentFilterSelect>
            <BillingDataContainerModalContentFilterButton
              onClick={() => this.filter()}
            >
              Buscar
            </BillingDataContainerModalContentFilterButton>
            <BillingDataContainerModalContentFilterButtonWhite
              onClick={() => this.props.closeModal()}
            >
              Fechar
            </BillingDataContainerModalContentFilterButtonWhite>
          </BillingDataContainerModalContentFilter>
          <BillingDataContainerModalContentGrid>
            <BillingDataContainerModalContentGridLoading
              style={
                this.state.view_loading
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <BillingDataContainerModalContentGridLoadingContent>
                <img alt='img' src={loading} />
              </BillingDataContainerModalContentGridLoadingContent>
            </BillingDataContainerModalContentGridLoading>
            <BillingDataContainerModalContentGridColumn>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    {this.props.grid.map((data) => {
                      return (
                        <th style={data.css != undefined ? data.css : {}}>
                          {this.ifnull(data.title, "")}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {dados.length != 0 ? (
                    dados.map((data) => {
                      return (
                        <tr>
                          <td className="checkbox-size">
                            <label className="control control--checkbox">
                              <input
                                type="checkbox"
                                onClick={(e) => this.props.select(e)}
                                value={
                                  "{" +
                                  this.props.checkboxField.map((obj) => {
                                    return (
                                      '"' +
                                      [obj.title] +
                                      '":"' +
                                      this.ifnull(data[obj.field], "") +
                                      '"'
                                    );
                                  }) +
                                  "}"
                                }
                              />
                              <div className="control__indicator__orange"></div>
                            </label>
                          </td>
                          {this.props.grid.map((obj) => {
                            return (
                              <td style={obj.css != undefined ? obj.css : {}}>
                                {this.ifnull(data[obj.field], "")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })
                  ) : (
                    <div></div>
                  )}
                </tbody>
              </table>
            </BillingDataContainerModalContentGridColumn>
          </BillingDataContainerModalContentGrid>
        </BillingDataContainerModalContent>
      </BillingDataContainerModal>
    );
  }
}


export class ModalParceiro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      view_loading: false,
      texto_buscado: "",
      codigo_parceiro: "",
      cpfcnpj_parceiro: "",
      nome_parceiro: "",
    };
    this.config = this.props.config;
  }

  componentDidMount() {
    if (this.props.title_filter == "sem filtro" || this.props.autosearch) {
      this.filtrar();
    }
  }

  filtrar = async () => {
    try {
      this.setState({ view_loading: true });
      // console.log(this.props.call.param);

      const response = await this.props.call.endpoint.post(
        "",
        "{" +
          this.props.call.param.map((data) => {
            return (
              '"' +
              [data.field] +
              '":"' +
              this[this.ifnull(data.find, "")][this.ifnull(data.field, "")] +
              '"'
            );
          }) +
          "}"
      );
      var data = response.data;
      this.setState({ dados: data, view_loading: false });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  changeInputField = async (e, value) => {
    this.setState({ [value]: e.target.value });
    if (e.key == "Enter") {
      this.filtrar();
    }
  };

  ifnull(a, b) {
    if (a == undefined || a == null || a == "") {
      return b;
    } else {
      return a;
    }
  }

  render() {
    const { dados } = this.state;

    return (
      <RegisterBudgetModal>
        <RegisterBudgetModalContent
          style={this.props.width != undefined ? this.props.width : {}}
        >
          <RegisterBudgetModalContentFilter>
            <RegisterBudgetModalContentFilterSelector>
              {typeof this.props.title_filter == "object" ? (
                this.props.title_filter.data.map((data) => {
                  return (
                    <>
                      <label> {data.title}: </label>
                      <input
                        name={data.field}
                        type="text"
                        onKeyPress={(e) => this.changeInputField(e, data.field)}
                        onChange={(e) => this.changeInputField(e, data.field)}
                      />
                    </>
                  );
                })
              ) : (
                <>
                  {this.props.title_filter != "sem filtro" ? (
                    <label>{this.props.title_filter}: </label>
                  ) : (
                    <div></div>
                  )}
                  {this.props.title_filter != "sem filtro" ? (
                    <input
                      name="texto_buscado"
                      type="text"
                      onKeyPress={(e) =>
                        this.changeInputField(e, "texto_buscado")
                      }
                      onChange={(e) =>
                        this.changeInputField(e, "texto_buscado")
                      }
                    />
                  ) : (
                    <div></div>
                  )}
                </>
              )}
            </RegisterBudgetModalContentFilterSelector>
            <RegisterBudgetResumeContentModalFilterButton
              onClick={() => this.filtrar()}
            >
              BUSCAR
            </RegisterBudgetResumeContentModalFilterButton>
            <RegisterBudgetResumeContentModalFilterButtonWhite
              onClick={() => this.props.FecharModal()}
            >
              FECHAR
            </RegisterBudgetResumeContentModalFilterButtonWhite>
          </RegisterBudgetModalContentFilter>
          <ModalContentGrid>
            <ModalContentGridLoading
              style={
                this.state.view_loading
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <ModalContentGridLoadingContent>
                <img alt="loading" src={loading} />
              </ModalContentGridLoadingContent>
            </ModalContentGridLoading>
            <ModalContentGridColumn>
              <table>
                <thead>
                  <tr>
                    {this.props.redirect_to_request ? (
                      <th>Ver pedido</th>
                    ) : (
                      <th></th>
                    )}
                    {this.props.grid.map((data) => {
                      return <th>{this.ifnull(data.title, "")}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {dados.length != 0 ? (
                    dados.map((data) => {
                      return (
                        <tr>
                          <td className="checkbox-size">
                            <label className="control control--checkbox">
                              <input
                                type="checkbox"
                                onClick={(e) => this.props.seleciona(e)}
                                value={
                                  "{" +
                                  this.props.checkboxField.map((obj) => {
                                    return (
                                      '"' +
                                      [obj.title] +
                                      '":"' +
                                      this.ifnull(data[obj.field], "") +
                                      '"'
                                    );
                                  }) +
                                  "}"
                                }
                              />
                              <div className="control__indicator__orange"></div>
                            </label>
                          </td>
                          {this.props.grid.map((obj) => {
                            return <td>{this.ifnull(data[obj.field], "")}</td>;
                          })}
                        </tr>
                      );
                    })
                  ) : (
                    <div></div>
                  )}
                </tbody>
              </table>
            </ModalContentGridColumn>
          </ModalContentGrid>
        </RegisterBudgetModalContent>
      </RegisterBudgetModal>
    );
  }
}


export default Modal;
